import './Header.scss';
import logo from "../../../assets/images/nps-logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { tokenState } from "../../../atoms/token";
import { useRecoilState } from 'recoil';
import environment from '../../../environment/environment';

export default function Header() {
  const location = useLocation();
  const { isAuthenticated, user, login, logout } = useAuth();
  const [token] = useRecoilState(tokenState);

  const userDisplay = () => {
    if (environment.publicMode) return null;
    console.log('husky header', user, isAuthenticated);
    if (!isAuthenticated || !user) return null;
    // if ((!token && localStorage.getItem(`access_token`) == 'undefined') 
    //     || localStorage.getItem(`access_token`) == 'undefined' 
    //     || localStorage.getItem(`access_token`) == null) { 
    //   logout();
    // };
    console.log('husky auth or user', user);
    return (
      <span>
        You are logged in as: {user.profile.name} &nbsp;&nbsp;
        <Button
          id="login"
          variant="contained" 
          startIcon={<FontAwesomeIcon icon={["fas", "sign-out"]} />}
          className="button"
          onClick={logout}>
            Logout
        </Button>
      </span>
    );
  }

  return (
    <div className="header">
      <div>
        <img src={logo} alt="National Park Service logo" className='logo'></img>
        <span className='nps'>
          National Park Service
        </span>
      </div>

      <div className='user'>
        {userDisplay()}
      </div>
    </div>
  );
}